import React, { PropsWithChildren, useContext } from "react"
import { useLayout } from "./layout"
import QuizEmbedInfoContext from "./QuizEmbedInfoContext"

const SetQuizLayoutClasses: React.FC<PropsWithChildren> = ({ children }) => {
  const { type: layoutType, palletteId, mode } = useLayout()
  const { host } = useContext(QuizEmbedInfoContext)

  const className = [
    "neo__quiz",
    `neo__quiz--${layoutType}`,
    `neo__quiz--${mode}`,
    `neo__quiz--${host}`,
    `neo__quiz--palette${palletteId}`,
  ].join(" ")

  return <div className={className}>{children}</div>
}

export default SetQuizLayoutClasses
